import React from 'react';
import Header from '../../Components/Header/Header';

const Projects = () => {
    return (
        <div>
            <Header></Header>
            <div className="h-screen flex justify-center items-center">
                All projects Will be shown Hare
            </div>
        </div>
    );
};

export default Projects;